import React from 'react'
import Radiobutton from 'components/marketplace/radiobutton';

const RoadworthyType = (props) => {
  const types = props.roadworthyType
  let renderRadiobutton = null;

  if ((types && types[0]) !== undefined) {
    renderRadiobutton = types.map((type, index) => {
      if (type.length > 0) {
        return <Radiobutton key={index} option={type} handleChange={props.handleChange} checked={props.selectedValue == type}/>
      }
     })
  } else {
    return (<p>Option not found</p>);
  }

  return (
    <div className="btn-group" role="group" data-toggle="buttons">
      {renderRadiobutton}
    </div>
  )
}

export default RoadworthyType
